import React from 'react';
import '../static/style/floating_data.css';
function Floatingdata(props) {
    return (
        <div className='data'>
            {/* Extra data reg the department */}
            
            {/*Extra data reg department, as of now it is just a placeholder*/}
            <br>
            </br>
            {/*Need to get props element and print related elements from a data_department.json file*/}
        </div>
    );
}

export default Floatingdata;
